export const SHOP_AUTH_API_BASE = "/shop/api/v1";
